import { z } from 'zod';

export const MediaTypeEnum = z.enum([
  'billboard',
  'backlight',
  'citylight',
  'słup',
  'cityscroll',
  'konstrukcja',
  'wielki format',
  'mural',
  'dooh',
  'inne',
]);
export type MediaType = z.infer<typeof MediaTypeEnum>;

export const MediaUnitVariantSchema = z.object({
  id: z.number(),
  mediaType: MediaTypeEnum,
  // General (multi-type)
  videocardLink: z.string().nullable(),
  // Mural-specific
  muralCostStandard: z.number().nullable(),
  muralCostAntismog: z.number().nullable(),
  muralElement3d: z.boolean().nullable(),
  muralLedTape: z.boolean().nullable(),
  muralNeonLed: z.boolean().nullable(),
  muralFluoUv: z.boolean().nullable(),
  // Konstrukcja / highway-specific
  roadNumber: z.string().nullable(),
  // Digital-specific
  digitalSpotDurationSeconds: z.number().int().nullable(),
  digitalLoopSize: z.number().int().nullable(),
  digitalScreenResolution: z.string().nullable(),
  digitalScreenHours: z.string().nullable(),
  digitalFrequency: z.string().nullable(),
  digitalDailyEmissions: z.number().int().nullable(),
  digitalTotalCampaignEmissions: z.number().int().nullable(),
  digitalSpotPrice: z.number().nullable(),
  // DOOH screen-specific (dooh-import-template capability)
  screensCount: z.number().int().nullable(),
  isOutdoor: z.boolean().nullable(),
  digitalScreenSizeInches: z.number().nullable(),
  // MPK-specific
  mpkVehicleType: z.string().nullable(),
  mpkLineNumbers: z.string().nullable(),
  mpkPlacementOnVehicle: z.string().nullable(),
  mpkVehicleCount: z.number().int().nullable(),
});
export type MediaUnitVariant = z.infer<typeof MediaUnitVariantSchema>;
